import axios from 'axios'
import RuntimeUtils from 'src/common/js/runtimeUtils'
import { $get, $post, $put } from 'src/utils/httpUtil'
import { formatTime, formatSzie, base64UrlEncode } from 'src/utils/commonUtils'

import $, { data } from 'jquery'
// import { StorageService } from '@aecworks/bimbox-bimserver-sdk-js';
// // import * as config from '../../../services/bimserver/config/config';
// const REQUEST_TIMEOUT = 60000;

// // const getShareInfo = () => {
// //     return localStorage.shareInfo ? JSON.parse(localStorage.shareInfo) : '';
// // };

// const getUserInfo = () => {
//     return localStorage.userInfo ? JSON.parse({"access_token":"eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE1ODU1NjMzNTksInVzZXJfbmFtZSI6IjRwdWZZbUhRMXowIiwiYXV0aG9yaXRpZXMiOlsiUk9MRV9VU0VSIiwiUk9MRV9VU0VSX0FETUlOIl0sImp0aSI6Ijc2Yzg5YTU0LWVmMGQtNDZiMy04MGY4LWMyMGFhMWRlYWIzNiIsImNsaWVudF9pZCI6IjFoWE5DTzNEaklkYzJhOWRWWjFZN2t0WSIsInNjb3BlIjpbIm9idjpyZWFkIiwib2J2OndyaXRlIiwiYm94OnJlYWQiLCJib3g6d3JpdGUiLCJjb2xsYWI6cmVhZCIsImNvbGxhYjp3cml0ZSJdfQ.GrEnGDq-DPofoe1HbblpbTu__GtzS0dIc3Q7Jd5oNZK5r5CC6R1LLwtYfqJFTn9eR4ttyQQJjqgLwy_2PvcjoRgLsScdLpBnaGqrXGX51QgK99SOQN2sqMiSsXpV3IYg1d-fzfSlBOW3Qzl31_pP_s-lpcZglLe9HmFQjAioY3ANKe6dpyFba_ZTNjT81rUZS5CN2xn7V13CMSy2dYKaZTGXw2UZl-_S9Fixjibo8qsnFej_CQuTmeC8q-2XSAWTxlEA_w8KtSu6TooVIr5NnDiAfqkgBlrDFhwb30WMUyCBi6v3FXa33kNj1TRImrXffLuWfImzpXmTzDPuCrtFWQ","token_type":"bearer","expires_in":"604799","scope":"obv:read%20obv:write%20box:read%20box:write%20collab:read%20collab:write","jti":"76c89a54-ef0d-46b3-80f8-c20aa1deab36"}) : '';
// };

// class ContextBase {

//     constructor(serviceEndpoint, withCredentials) {
//         this.serviceEndpoint = serviceEndpoint;
//         this.info = getUserInfo();
//         this.withCredentials = typeof withCredentials === undefined ? true : withCredentials;
//     }

//     get requestTimeout() {
//         return 30000;
//     }
// }

// const contextBase = new ContextBase( `${BASE_URL()}/bimserver/storage/v3`, true);
// const storageService = new StorageService(contextBase);

// export const getAllBucket = () => {
//     new Promise((resolve, reject) => {
//         storageService
//             .getBucket()
//             .then((res) => {
//                 resolve({ data: res });
//             })
//             .catch((err) => {
//                 reject(err);
//             });
//     });
// };

/**
 * 查询所有文件状态
 */
export const getAllObjectsStatus = (bucketKey) =>{
  return new Promise((resolve, reject) => {
    const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/buckets/${bucketKey}`
    $get(url).then((res) => {
      resolve(res)
    })
  })
}


/**
 * 获取当前页面的文件对象
 */
export const getPageObjects = (bucketKey, data) =>{
  return new Promise((resolve, reject) => {
    const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/buckets/${bucketKey}`
    $get(url, data)
      .then((res) => {
        let data = {}
        if (res.data.objects.length !== 0) {
          data.data = res.data.objects.map((ele) => ({
            fileName: ele.object_key,
            fileUrn: `urn:bimbox.object:${bucketKey}/${ele.object_key}`,
            uploadTime: formatTime(ele.create_at),
            size: formatSzie(ele.size),
            consumingTime: {
              obv: '-',
              lod: '-',
            },
            modelStatus: {
              obv: null,
              lod: null,
            },
            percentage: 0,
          }))
        }
        data.totalObjects = res.data.totalObjects
        data.totalPages = res.data.totalPages
        resolve(data)
      })
      .catch((err) => {
        reject(null)
      })
  })
}


/**
 * 获取文件下载url
 */
export const getObjectsDownUrl = (bucketKey, objectKey) => {
  const clientId = RuntimeUtils.instance.getClientId()
  const redirectUri = RuntimeUtils.instance.getPassportServiceHostname()
  const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/buckets/${bucketKey}/objects/${base64UrlEncode(
    objectKey,
  )}/directpresignedurl`
  const data = {
    bucketKey,
    objectKey,
    objectKeyEncoding: 'base64',
  }
  return new Promise((resolve, reject) => {
    $.ajax({
      type: 'GET',
      url,
      crossDomain: true, // 设置跨域为true
      xhrFields: {
        withCredentials: true, // 默认情况下，标准的跨域请求是不会发送cookie的
      },
      beforeSend (request) {
        request.setRequestHeader('Content-Type', 'application/json')
      },
      data,
      success (res) {
        resolve(res)
      },
      error (err) {
        console.log(err.responseText)
        switch (err.status) {
          case 401:
          case 403:
            window.location = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getCloudServiceHostname()}/bimserver/auth/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&display=web&detailed_user_info=true&state=${RuntimeUtils.instance.getState()}`
            break
          case 500:
            this.$message.error('服务器内部错误')
          default:
            console.error(err.responseText)
        }
        reject(err)
      },
    })
  })
}

/**
 * 获取所有的bucket
 *
 */
export const getAllBucket = () => {
  return new Promise((resolve, reject) => {
    const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/buckets`
    $get(url).then((res) => {
      resolve(res)
    })
  })
}


/**
 * 获取对应bucket key 下所有的object
 *
 */
export const getAllObjectByBucketKey = (bucketKey) =>{
  return new Promise((resolve, reject) => {
    const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/buckets/${bucketKey}`
    $get(url)
      .then((res) => {
        resolve(res.data)
      })
      .catch(reject)
  })
}


// 创建的bucket
/*
*
    bucketKey: "用户Id"
*/
export const createBucket = (data) =>{
  return new Promise((resolve, reject) => {
    const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/buckets`
    $post(url, data).then((res) => {
      resolve(res)
    })
  })
}


/**
 * 获取多个模型上传地址
 *
 */
export const getAllUploadUrls = (bucketKey, objectKeyArr) =>{
  return new Promise((resolve, reject) => {
    const _self = this
    // 先取token
    const tempToken = localStorage.getItem('userToken')
    if (tempToken === null) {
      reject(false)
    }
    // 循环获取objectKeyArr
    const uploadUrlPro = []
    if (objectKeyArr.length !== 0) {
      objectKeyArr.forEach((objectKey) => {
        const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getCloudServiceHostname()}/bimserver/storage/v3/uploadUrl?type=7&expire=60000&bucketKey=${bucketKey}&objectKey=${objectKey}`
        const ProEle = $.ajax({
          type: 'GET',
          url,
          beforeSend (request) {
            request.setRequestHeader('Authorization', `Bearer ${tempToken}`)
          },
          processData: false,
        })
        uploadUrlPro.push(ProEle)
      })
    }
    Promise.all(uploadUrlPro)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })

}

/**
 * 获取单个模型上传地址
 *  bucketKey: bucket主键值
 objectKey  object主键值
 type  url的类型 default 7
 expire  超时时间 60000
 *
 */
export const getUploadUrl = (params) => {
  // let url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getCloudServiceHostname()}/bimserver/storage/v3/uploadUrl?type=7&expire=60000&bucketKey=${bucketKey}&objectKey=${objectKey}`
  return new Promise((resolve, reject) => {
    const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/uploadUrl`
    $get(url, params).then((res) => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 分片上传绑定文件md5值
 * @param data
 */
export const bindMd5 = (data) => {
  return new Promise((resolve, reject) => {
    const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getCloudServiceHostname()}${data.uploadUrl}&md5=${data.md5}`
    $.ajax({
      type: 'POST',
      url,
      beforeSend (request) {
        request.setRequestHeader('x-bimserver-upload-url', data.signature)
      },
      crossDomain: true, // 设置跨域为true
      xhrFields: {
        withCredentials: true // 默认情况下，标准的跨域请求是不会发送cookie的
      },
      success (res) {
        resolve(res)
      },
      fail (err) {
        reject(err)
      }
    })
  })
}

/**
 * 修改文件扩展属性
 *
 */
export const updateFileExtAttr = (bucketKey, objectKey, fileName) => {
  return new Promise((resolve, reject) => {
    const base64ObjectKey = base64UrlEncode(objectKey)
    const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/buckets/${bucketKey}/objects/${base64ObjectKey}/info?objectKeyEncoding=base64`
    const extAttr = {
      ext_attr: {
        _filename_: fileName,
      },
    }
    $put(url, extAttr)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
/**
 * 删除指定的Bucket中一个文件Object的对象模型
 *
 */
export const getObjectViewToken = () => {
  return new Promise((resolve, reject) => {
    const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/viewToken`
    $get(url).then((res) => {
      resolve(res)
    })
  })
}

/**
 * 获取分享的token
 *
 */
export const getShareViewToken = (data) => {
  return new Promise((resolve, reject) => {
    const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/share/token?shareId=${
      data.shareId
    }&password=${data.password}`
    $post(url).then((res) => {
      resolve(res)
    })
  })
}

/**
 * 删除指定的Bucket中一个文件Object的对象模型
 *
 */
export const deleteObject = (bucketKey, objectKey) => {
  const clientId = RuntimeUtils.instance.getClientId()
  const redirectUri = RuntimeUtils.instance.getPassportServiceHostname()
  const base64ObjectKey = base64UrlEncode(objectKey)
  const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/buckets/${bucketKey}/objects/${base64ObjectKey}?objectKeyEncoding=base64`
  return new Promise((resolve, reject) => {
    $.ajax({
      type: 'DELETE',
      url,
      crossDomain: true, // 设置跨域为true
      xhrFields: {
        withCredentials: true, // 默认情况下，标准的跨域请求是不会发送cookie的
      },
      beforeSend (request) {
        request.setRequestHeader('Content-Type', 'application/json')
      },
      complete (res) {
        if (res.status === 200) {
          resolve(200)
        }
      },
      error (err) {
        switch (err.status) {
          case 200:
            resolve(200)
            break
          case 401:
          case 403:
            window.location = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getCloudServiceHostname()}/bimserver/auth/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&display=web&detailed_user_info=true&state=${RuntimeUtils.instance.getState()}`
            break
          case 500:
            console.error('服务器内部错误')
          default:
            console.error(err.responseText)
        }
        reject(err)
      },
    })
  })
}

/**
 * 删除指定的Bucket中一个文件Object的对象模型
 *
 */
export const getThumbnail = (bucketKey, objectKey) => {}



// WEBPACK FOOTER //
// ./src/utils/modelUtils.js